export default __webpack_public_path__ + "static/media/cow-upload-1.98388e7b.jpeg";